import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validator for rich-text (HTML) fields.
 * Strips all HTML tags and checks that the remaining text is non-empty.
 * Handles cases where editors emit empty markup like `<div><br></div>`.
 */
export function nonEmptyHtml(control: AbstractControl): ValidationErrors | null {
    const text = (control.value ?? '').replace(/<[^>]*>/g, '').trim();
    return text.length > 0 ? null : { required: true };
}
